export default "__VITE_ASSET__Dwcp8ZSG__"